const focusOuline = () => {
  document.body.addEventListener('keyup', e => {
    if (e.which === 9) {
      document.documentElement.classList.remove('no-focus-outline');
    }
  });
};

export default focusOuline();



// WEBPACK FOOTER //
// ./src/scripts/modules/focus-outline.js